import GameClient from '@/game-client/GameClient';
import GameClientLoadingWrapper from '@/game-client/anexes/GameClientLoadingWrapper';

import GameWindow from '@/features/GameWindow/GameWindow';
import DefaultControlsOverlay from '@/features/DefaultControlsOverlay/DefaultControlsOverlay';
import HomeRouteEffects from './HomeRouteEffects';
import MaintenanceWrapper from '@/features/Maintenance/MaintenanceWrapper';

import DebugWrapper from '@/debug/DebugWrapper';
import GeolocationWrapper from '@/geolocation/screens/GeolocationWrapper';
import { MessageOverlay } from '@/features/Showoff';
import { NetPositionOverlay } from '@/features/NetPosition/NetPositionOverlay';
import { UILocker } from '@/features/NetPosition/UILocker';
import { GameSwitchOverlay } from '@/features/GameSwitch/GameSwitchOverlay';

const HomeConfiguration = () => {
  return (
    <DebugWrapper>
      <GeolocationWrapper>
        <HomeRouteEffects>
          <MaintenanceWrapper>
            <GameClientLoadingWrapper>
              <GameClient />
              <DefaultControlsOverlay />
              <NetPositionOverlay />
              <GameSwitchOverlay />
            </GameClientLoadingWrapper>
            <GameWindow />
            <MessageOverlay />
            <UILocker />
          </MaintenanceWrapper>
        </HomeRouteEffects>
      </GeolocationWrapper>
    </DebugWrapper>
  );
};

export default HomeConfiguration;
